module.exports = __webpack_public_path__ + "img/magnifying-glass.781706b4.svg";